import { BreakpointObserver } from '@angular/cdk/layout';
import { AfterViewInit, Component, ElementRef, Inject, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-revenue-breakdown-chart',
    templateUrl: './revenue-breakdown-chart.component.html',
    styleUrls: ['./revenue-breakdown-chart.component.scss'],
    standalone: false
})
export class RevenueBreakdownChartComponent implements OnInit, OnDestroy, AfterViewInit {
  width = 0;
  height = 0;
  gradient: any = null;
  isMobile = false;

  private subscriptions: Subscription[] = [];
  public isBrowser: boolean;
  public chartsLoader = false;
  public selectedTab = '5Y';
  public lastTime = new Date();
  public currentPrice = 0;
  public lastDate = new Date();
  public priceChange = 0;
  public priceChangePercent = 0;
  public hasData = false;

  @ViewChild('chart', { read: ElementRef }) pieChart!: ElementRef;
  private chart: any;

  @Input() set screeningInfo(value: any) {
    if (value && this.isBrowser) {
      this.chartData[0].data = [
        value?.['halal'],
        value?.['questionable'],
        value?.['notHalal']
      ];
      this.hasData = true;
    }
  }

  public chartData: any[] = [
    {
      data: [],
      backgroundColor: [
        '#39A939',
        '#F6AF0D',
        '#C70707'
      ]
    }
  ];

  public chartLabels = ['Halal', 'Doubtful', 'Not Halal'];

  public chartOptions: any = {
    cutoutPercentage: 50,
    tooltips: {
      enabled: false
    }
  };

  constructor(
    private observer: BreakpointObserver,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  async ngAfterViewInit(): Promise<void> {
    if (this.isBrowser) {
      const { Chart } = await import('chart.js');
      const { BaseChartDirective } = await import('ng2-charts');
      this.chart = BaseChartDirective;
    }
  }

  ngOnInit(): void {
    if (this.isBrowser) {
      this.subscriptions.push(
        this.observer.observe('(max-width: 768px)').subscribe(result => {
          this.isMobile = result.matches;
        })
      );
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
